import StudentEnquiryForm from '../commonfile/StudentEnquiryForm'


const AddUserList = () => {


    return (
        <>
            <StudentEnquiryForm />
        </>

    )
}

export default AddUserList